const SITENAMES = {
  fleetpartners: 'FleetPartners',
  fleetplus: 'FleetPlus',
  fleetsmart: 'FleetSmart',
};

// Set sitename at localhost
const LOCALHOST = 'fleetplus';

const getSiteName = () => {
  let siteName = SITENAMES[LOCALHOST];

  Object.keys(SITENAMES).map(key => {
    if (location.host.includes(key)) siteName = SITENAMES[key];
    return null;
  });
  return siteName;
};

export default getSiteName();



// WEBPACK FOOTER //
// ./src/config.js